/**
 * @typedef {Object} AdParam
 * @property {boolean|null} singleAd
 * @property {string|null} section
 * @property {boolean} development
 * @property {string|null} client
 * @property {number|null} intervalPopUp
 * @property {boolean} isDiagram
 *
 */

/*
 * @return {AdParam}
 */

export function getParam () {
  return {
    singleAd: document.currentScript.getAttribute('data-singleAd') ?? null,
    section: document.currentScript.getAttribute('data-section') ?? null,
    development: (document.currentScript.getAttribute('data-development') ?? false) == 'true',
    client: document.currentScript.getAttribute('data-client') ?? null,
    intervalPopUp: document.currentScript.getAttribute('data-intervalPopUp') ?? 60,
    isDiagram: (document.currentScript.getAttribute('data-isDiagram') ?? '') == 'true'
  }
}
